import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from "react-pro-sidebar";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import VideoCallOutlinedIcon from "@mui/icons-material/VideoCallOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MonitorIcon from "@mui/icons-material/Monitor";
import EngineeringIcon from "@mui/icons-material/Engineering";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import SmsIcon from "@mui/icons-material/Sms";
import TocIcon from "@mui/icons-material/Toc";
import AddIcon from "@mui/icons-material/Add";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  useSignOut,
  useIsAuthenticated,
  useAuthUser,
  useAuthHeader,
} from "react-auth-kit";
import { useGetNotifications } from "./useNotifications";
import { useEffect, useState } from "react";
import { Badge } from "@mui/material";
import ConfirmSignoutDialog from "../ConfirmSignoutComponent/ConfirmSignout";
import { deviceCategories } from "../DeviceComponents";
import logo from "../../logos/health3000_logo.png";
import { prettify } from "../../utils/utils";

function AppSidebar() {
  const { collapseSidebar } = useProSidebar();
  const isAuthenticated = useIsAuthenticated();
  const authUser = useAuthUser();
  const authHeader = useAuthHeader();

  const signOut = useSignOut();
  const navigate = useNavigate();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const notificationsPolling = useGetNotifications(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // show badge
    if (
      notificationsPolling?.data?.notifications !== undefined &&
      notificationsPolling?.data?.notifications !== notifications
    ) {
      setNotifications(notificationsPolling.data.notifications);
    }
  }, [notificationsPolling.isFetching]);

  const handleConfirmDialogOpen = () => {
    setConfirmDialogOpen(true);
  };
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleSignOut = () => {
    setConfirmDialogOpen(false);
    signOut();
    navigate("/login", { replace: true });
  };

  const renderKitsMenuItem = () => (
    <MenuItem
      key="kits"
      component={<Link to="/kits" />}
      icon={<Inventory2OutlinedIcon />}
    >
      Kits
    </MenuItem>
  );

  const renderDevicesSubMenu = () => (
    <SubMenu label="Dispositivi" icon={<DeviceHubIcon />}>
      {deviceCategories.map((el) => (
        <MenuItem
          key={el}
          component={<Link to="/devices" state={{ filter: el }} />}
        >
          {prettify(el)}
        </MenuItem>
      ))}
      {authUser()?.role !== 3 && (
        <MenuItem key="gateway" component={<Link to="/h3kb" />}>
          Gateway
        </MenuItem>
      )}
    </SubMenu>
  );

  const conditionalRoleRendering = () => {
    // CONTROL ROOM
    if (authUser()?.role === 1) {
      return (
        <>
          <MenuItem
            key="controlroom"
            component={<Link to="/controlroom" />}
            icon={<MonitorIcon />}
          >
            Control Room
          </MenuItem>
          <MenuItem
            key="patients"
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key="doctors"
            component={<Link to="/doctors" />}
            icon={<EngineeringIcon />}
          >
            Professionisti Sanitari
          </MenuItem>
          <MenuItem
            key="telemonitoraggi"
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          <MenuItem
            key="televisite"
            component={<Link to="/televisite" />}
            icon={<VideoCallOutlinedIcon />}
          >
            Televisite
          </MenuItem>
          {renderDevicesSubMenu()}
          {renderKitsMenuItem()}
          <MenuItem
            key="monitoralert"
            component={<Link to="/monitoralert" />}
            icon={<EngineeringIcon />}
          >
            Monitor Alert
          </MenuItem>
          <MenuItem
            key="communications"
            component={<Link to="/communications" />}
            icon={<SmsIcon />}
          >
            Comunicazioni
          </MenuItem>
          <MenuItem
            key="dailyreports"
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key="profile"
            component={<Link to="/profile" />}
            icon={
              <Badge
                color="error"
                badgeContent={
                  notifications.length > 0 ? notifications.length : null
                }
              >
                <PeopleOutlinedIcon />
              </Badge>
            }
          >
            Mio profilo
          </MenuItem>
          <MenuItem
            key="users"
            component={<Link to="/users" />}
            icon={<AddIcon />}
          >
            Gestione utenti
          </MenuItem>
          <MenuItem
            key="security"
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key="logout"
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
      // ADMIN STRUTTURA
    } else if (authUser()?.role === 2) {
      return (
        <>
          <MenuItem
            key="patients"
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key="doctors"
            component={<Link to="/doctors" />}
            icon={<EngineeringIcon />}
          >
            Professionisti Sanitari
          </MenuItem>
          <MenuItem
            key="telemonitoraggi"
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          {renderDevicesSubMenu()}
          {renderKitsMenuItem()}
          <MenuItem
            key="dailyreports"
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key="users"
            component={<Link to="/users" />}
            icon={<AddIcon />}
          >
            Gestione utenti
          </MenuItem>
          <MenuItem
            key="security"
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key="logout"
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
      // PROF SANITARIO
    } else {
      return (
        <>
          <MenuItem
            key="patients"
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key="televisite"
            component={<Link to="/televisite" />}
            icon={<VideoCallOutlinedIcon />}
          >
            Televisite
          </MenuItem>
          <MenuItem
            key="telemonitoraggi"
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          {renderDevicesSubMenu()}
          {renderKitsMenuItem()}
          <MenuItem
            key="communications"
            component={<Link to="/communications" />}
            icon={<SmsIcon />}
          >
            Comunicazioni
          </MenuItem>
          <MenuItem
            key="dailyreports"
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key="profile"
            component={<Link to="/profile" />}
            icon={<PeopleOutlinedIcon />}
          >
            Mio profilo
          </MenuItem>
          <MenuItem
            key="security"
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key="logout"
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
    }
  };

  return (
    <>
      <ConfirmSignoutDialog
        open={confirmDialogOpen}
        handleCancel={handleConfirmDialogClose}
        handleConfirm={handleSignOut}
      />
      <Sidebar style={{ height: "100vh" }} defaultCollapsed={false}>
        <Menu>
          <MenuItem
            key="sidebar-toggle"
            icon={<MenuOutlinedIcon />}
            onClick={() => {
              collapseSidebar();
            }}
            style={{ textAlign: "center" }}
          >
            {" "}
            <img src={logo} alt="health3000 logo" style={{ width: "100%" }} />
          </MenuItem>

          <MenuItem
            key="home"
            component={<Link to="/" />}
            icon={<HomeOutlinedIcon />}
          >
            Home
          </MenuItem>

          {isAuthenticated() ? (
            conditionalRoleRendering()
          ) : (
            <MenuItem
              key="login"
              onClick={() => {
                collapseSidebar();
              }}
              component={<Link to="/login" />}
              icon={<LoginOutlinedIcon />}
            >
              Login
            </MenuItem>
          )}
        </Menu>
      </Sidebar>
    </>
  );
}

export default AppSidebar;
